<template>
  <v-dialog
    v-model="dialog"
    max-width="450px"
    style="height: 100px !important"
    scrollable
    @click:outside="$emit('changeValue', false)"
    @keydown="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title id="title-dialog-hint-val" class="headline pt-2">Primeiros 100 valores do campo</v-card-title>
      <v-card-text class="pb-0 pt-3">
        <div>
          <v-data-table
            id="v-data-table-dialog-hint-val"
            :headers="headers"
            :items="items"
            hide-default-footer
            :loading="loading"
            loading-text="Carregando... Por favor aguarde"
            no-data-text="Nenhum valor encontrado"
            disable-pagination
            mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr>
                <td :id="'hint-value-' + row.index" class="button" width="100%" style="text-align: justify">
                  {{ row.item.value }}
                </td>
                <td align="right" style="padding-right: 0px !important">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-btn icon @click="copyToClipboard('hint-value-' + row.index)">
                          <v-icon color="primary" size="22">mdi-content-copy</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <span>Clique aqui para copiar o valor</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pr-6 pt-2">
        <v-spacer />
        <v-btn text class="pa-12 text-h2" @click="$emit('changeValue', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService.js';

  export default {
    props: {
      showDialog: {
        type: Boolean,
        required: true
      }
    },

    emits: ['changeValue'],

    data() {
      return {
        dialog: false,
        loading: false,
        loadingData: {},
        items: [],
        headers: [{ text: 'Campos', value: 'value', sortable: false }, { sortable: false }],
        campoFiltrado: ''
      };
    },

    methods: {
      getHintValores(campo, tabela) {
        this.campoFiltrado = '';
        if (!campo) {
          this.$toast.warning('Selecione ao menos um campo para obter dicas de valores.', '', { position: 'topRight' });
          return;
        }

        this.$emit('changeValue', true);
        if (this.loading && this.loadingData.campo == campo && this.loadingData.campo == campo) {
          return;
        }

        this.items = [];
        this.loading = true;
        ((this.loadingData = { campo: campo, tabela: tabela }),
          RelatoriosService.getHintValores(campo, tabela)
            .then((response) => {
              response.data.valores.forEach((valor) => {
                this.items.push({ value: valor });
              });
              this.campoFiltrado = campo;
            })
            .catch((error) => {
              console.error(error);
              this.$toast.error('Erro ao recuperar as possibilidades de valores para filtros.', '', { position: 'topRight' });
            })
            .finally(() => {
              this.loading = false;
              this.loadingData = {};
            }));
      },

      copyToClipboard(idElement) {
        let text = document.getElementById(idElement).textContent.trim();
        if (navigator.clipboard) {
          this.$toast.success(`Valor para campo: {${this.campoFiltrado}} copiado`, '', { position: 'topRight' });
          return navigator.clipboard.writeText(text);
        } else if (window.clipboardData && window.clipboardData.setData) {
          window.clipboardData.setData('Text', text);
          this.$toast.success(`Valor para campo: {${this.campoFiltrado}} copiado`, '', { position: 'topRight' });
          return Promise.resolve();
        } else {
          const input = document.createElement('input');
          input.setAttribute('type', 'text');
          input.value = text;
          document.body.append(input);
          input.focus();
          input.select();
          document.execCommand('copy');
          input.remove();
          this.$toast.success(`Valor para campo: {${this.campoFiltrado}} copiado`, '', { position: 'topRight' });
          return Promise.resolve();
        }
      }
    },

    watch: {
      showDialog(newValue) {
        this.dialog = newValue;
      },

      loading(value) {
        this.headers[0].text = value ? '' : 'Campos';
      }
    }
  };
</script>

<style>
  #title-dialog-hint-val {
    padding-left: 32px;
    font-size: 15px !important;
    text-align: initial;
    font-weight: bold;
  }

  #v-data-table-dialog-hint-val table thead tr th {
    font-weight: 400;
    font-size: 14px;
    height: 36px;
  }

  #v-data-table-dialog-hint-val table tbody tr td {
    word-wrap: break-word;
    max-width: 240px;
    font-size: 12.5px;
    padding: 0px 8px !important;
    height: 37px;
  }

  #v-data-table-dialog-hint-val table tbody tr td .v-textarea {
    padding-top: 8px;
    margin-left: 9px !important;
  }

  .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 70% !important;
  }

  .v-data-table__wrapper {
    overflow-x: visible;
    overflow-y: visible;
  }
</style>
